export const SAVE_DEMOGRAPHIC_INFO = 'SAVE_DEMOGRAPHIC_INFO';
export const STORE_USERS = 'STORE_USERS';
export const SET_USER_AS_RESEARCHER = 'SET_USER_AS_RESEARCHER';